export default __webpack_public_path__ + "static/media/prototype_starglitter.64b3a263.png";